import React from "react";

import Form from "./form";

import { Switch, Route, Redirect } from "react-router-dom";

import { LAYOUT_ADMIN_CONFIG_SETTING_FORM } from "../../navigation";

const Router = (props) => (
    <Switch>
        <Route
            path={LAYOUT_ADMIN_CONFIG_SETTING_FORM}
            render={(routeProps) => <Form alta {...props} {...routeProps} />}
        />
        <Redirect to={LAYOUT_ADMIN_CONFIG_SETTING_FORM} />
    </Switch>
);

export default Router;
